// Healthdot pre-pairing (HQS-2438) is a temporary workaround, meant to be removed as a whole:
// src/api/prepairing.ts, src/pages/PrePairingPage.tsx, src/pages/prePairing/ and the
// prePairing.* messages. This is the one switch the route, the menu entry and the add-patient
// wizard's pre-paired Healthdot popup read.

function isTrue(value: unknown): boolean {
  return (
    String(value ?? '')
      .trim()
      .toLowerCase() === 'true'
  );
}

/**
 * On by default, so the screen works as soon as it is deployed. Switched off per deployment
 * through the runtime config (`window.__APP_CONFIG__.prepairingDisabled`, written to config.js
 * by the container entrypoint from the REACT_APP_PREPAIRING_DISABLED environment variable;
 * Helm value `prepairing.disabled`), or at build time with REACT_APP_PREPAIRING_DISABLED=true.
 * Only the string "true" switches it off: a missing or empty value, or a placeholder envsubst
 * left in place, leaves it on.
 */
export const PREPAIRING_ENABLED = !(
  isTrue(process.env.REACT_APP_PREPAIRING_DISABLED) ||
  isTrue(window.__APP_CONFIG__?.prepairingDisabled)
);
